(function() {
  const MinimogTheme = window.MinimogTheme || {};

  MinimogTheme.Toast = {
    container: null,

    init() {
      if (this.container) return;
      this.container = document.createElement('div');
      this.container.className = 'm-toast-container';
      document.body.appendChild(this.container);
    },

    show({ type = 'info', title = '', message = '', duration = 5000 }) {
      this.init();

      const toast = document.createElement('div');
      toast.className = `m-toast m-toast--${type}`;

      const icons = {
        success: '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>',
        error: '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
        warning: '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>',
        info: '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>'
      };

      // Auto-titles if not provided
      if (!title) {
        const titles = {
          success: 'Success',
          error: 'Error',
          warning: 'Warning',
          info: 'Info'
        };
        // Use strings from theme if available
        if (window.MinimogStrings) {
          titles.success = window.MinimogStrings.success || titles.success;
          titles.error = window.MinimogStrings.error || titles.error;
          titles.warning = window.MinimogStrings.warning || titles.warning;
        }
        
        // Turkish fallbacks if strings are missing or in English
        const isTurkish = document.documentElement.lang === 'tr';
        if (isTurkish) {
          if (titles.success === 'Success') titles.success = 'Başarılı';
          if (titles.error === 'Error') titles.error = 'Hata';
          if (titles.warning === 'Warning') titles.warning = 'Uyarı';
          if (titles.info === 'Info') titles.info = 'Bilgi';
        }

        title = titles[type] || titles.info;
      }

      toast.innerHTML = `
        <div class="m-toast__icon">${icons[type] || icons.info}</div>
        <div class="m-toast__content">
          ${title ? `<div class="m-toast__title">${title}</div>` : ''}
          <div class="m-toast__message">${message}</div>
        </div>
        <div class="m-toast__close">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </div>
      `;

      this.container.appendChild(toast);

      // Trigger animation
      setTimeout(() => toast.classList.add('m-toast--show'), 10);

      const closeBtn = toast.querySelector('.m-toast__close');
      const dismiss = () => {
        toast.classList.remove('m-toast--show');
        setTimeout(() => toast.remove(), 400);
      };

      closeBtn.onclick = dismiss;

      if (duration > 0) {
        setTimeout(dismiss, duration);
      }
    }
  };

  // Bridge old Notification system to new Toast system
  MinimogTheme.Notification = {
    show(options) {
      // Map old parameters to new ones
      const toastOptions = {
        type: options.type === 'warning' ? 'error' : (options.type || 'info'),
        message: options.message || '',
        title: options.title || '',
        duration: options.last || options.delay || 5000
      };
      
      MinimogTheme.Toast.show(toastOptions);
    }
  };

  window.MinimogTheme = MinimogTheme;
})();
